import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import AtomAssistPage from "./AtomAssistPage";
import AtomAssistPageLoad from "./components/AtomAssistPageLoad";
import ChatAccessErrorBanner from "./components/ChatAccessErrorBanner";
import useAssistantNavigation from "./hooks/useAssistantNavigation";
import useLoadDialogue from "./hooks/useLoadDialogue";
import { useSyncPersonaToStore } from "./hooks/useSyncPersonaToStore";
import { useSetAtomAssistConfig } from "./hooks/useProductConfig";
import { useChatStore } from "./stores/ChatStore";

export interface AtomAssistChatPageParams {
  dialogueId: string;
}

const AtomAssistChatPage = () => {
  const { initialConfig } = useAssistantNavigation();
  const { dialogueId: dialogueIdParam } = useParams<AtomAssistChatPageParams>();
  const dialogueId = Number(dialogueIdParam);

  const { isChatReady, initialUserMessage, initialImages, initialSendId } =
    useChatStore();
  const [isLoading, setIsLoading] = useState(true);

  // Set product configuration for Atom Assist
  useSetAtomAssistConfig();

  // Chat pages don't sync URL parameters - store-only
  const { isError: isResolvePersonaError } = useSyncPersonaToStore({
    initialConfig: initialConfig || undefined,
    initialUserMessage: initialUserMessage, // Get from store
    allowUrlSync: false, // Chat pages are store-only
  });

  const {
    isError: isDialogueError,
    isSuccess: isDialogueSuccess,
    isNotFound,
  } = useLoadDialogue({
    initialUserMessage: initialUserMessage,
    restoreDocumentScope: true,
  });

  useEffect(() => {
    if (isDialogueSuccess) {
      setIsLoading(false);
    }
  }, [isDialogueSuccess, dialogueId]);

  if (isNotFound) {
    return <ChatAccessErrorBanner notFound />;
  }

  if (isResolvePersonaError || isDialogueError) {
    return <ChatAccessErrorBanner />;
  }

  if (isLoading || !isChatReady()) {
    return <AtomAssistPageLoad />;
  }

  return (
    <AtomAssistPage
      dialogueId={dialogueId}
      initialUserMessage={initialUserMessage}
      initialImages={initialImages}
      initialSendId={initialSendId}
    />
  );
};

export default AtomAssistChatPage;
